// components/MemberPortal/VerificationRejected.js
import React from 'react';

const VerificationRejected = ({ memberProfile, onRetry }) => {
  return (
    <div className="verification-rejected">
      <div className="status-header">
        <div className="status-icon rejected">❌</div>
        <h2>Verification Not Approved</h2>
        <p>We were unable to verify your club membership</p>
      </div>

      <div className="rejection-details">
        {memberProfile.rejection_reason && (
          <div className="rejection-reason">
            <h3>Reason:</h3>
            <p>{memberProfile.rejection_reason}</p>
          </div>
        )}
      </div>

      <div className="retry-options">
        <h3>Next Steps</h3>
        <p>You can try verification again with different documentation, or contact our support team for assistance.</p>

        <div className="action-buttons">
          <button className="retry-button" onClick={onRetry}>
            Try Verification Again
          </button>
          <a href="mailto:support@privateiq.golf" className="support-button">
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default VerificationRejected;